export default function VisionSection() {
  return (
    <section className="relative bg-white px-4 md:px-6 pt-24 md:pt-32">
      <div className="max-w-[1140px] mx-auto flex flex-col items-center">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 text-center leading-[1.2] mb-6">
          Built for the
          <br />
          long term
        </h2>
        <p className="font-body text-foreground-500 text-base md:text-lg text-center max-w-[640px] leading-relaxed mb-20">
          We do not chase trends. We invest in fundamentals that outlast them &mdash; clean code, sound architecture, and an engineering culture that values substance over speed.
        </p>
      </div>

      <div className="w-full h-[280px] md:h-[320px] relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20shapes%20in%20charcoal%20and%20warm%20gray%20tones%2C%20fluid%20monochrome%20compositions%2C%20seamless%20die-cut%20effect%20on%20white%20background%2C%20minimalist%20architectural%20pattern%2C%20soft%20gradient%20dissolve%20at%20edges%2C%20modern%20corporate%20abstract%20art%2C%20clean%20and%20professional%2C%20no%20text%20no%20people&width=1440&height=320&seq=darius-vision-banner&orientation=landscape"
          alt="Abstract geometric architectural composition representing engineering precision and modern design thinking"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white pointer-events-none" />
      </div>
    </section>
  );
}